/* eslint-disable react-hooks/exhaustive-deps */
import moment from 'moment-timezone'
import React, { useEffect, useState } from 'react'
import { Button, OverlayTrigger, Popover } from 'react-bootstrap'

import authorization from 'live/services/authorization'
import globalNotification from 'live/services/global-notification'
import i18n from 'live/services/i18n'

import { IOverviewAlarmEvent } from 'plugin-codaf-risk-ext-bowtie/BowtieManagment/components/AssetSelector/AssetSelector'
import { getAlarmTriggerLog, updateAcknowledge, updateSeenBy } from 'plugin-codaf-risk-ext-bowtie/services'
import { IBowtie } from 'plugin-codaf-risk-ext-bowtie/types'
import { IAlarmEvent } from 'plugin-codaf-risk-ext-bowtie/types/alarms'
import { AlarmAcknowledge } from 'plugin-codaf-risk-ext-bowtie/types/enums'

import { TriggerLogMessage } from './components/TriggerLogMessage/TriggerLogMessage'
import { statusAlarmReturnColor } from './enum/statusAlarm'
import { AlarmRiskBollNotification, AlarmDetailsContainer, RiskNameNotification } from './styles'

type IProps = {
    alarm: IOverviewAlarmEvent
    alarms: Map<number, IAlarmEvent>
    alarmBowties: IBowtie[]
    setAlarm: (k: IOverviewAlarmEvent) => void
}

const alarmType = [
    {
        value: AlarmAcknowledge.TRUE_ALARM,
        name: i18n('True Alarm')
    },
    {
        value: AlarmAcknowledge.FALSE_ALARM,
        name: i18n('False Alarm')
    },
    {
        value: AlarmAcknowledge.MISSING_ALARM,
        name: i18n('Missing Alarm')
    },
    {
        value: AlarmAcknowledge.DISMISS_ALARM,
        name: i18n('Dismiss Alarm')
    }
]

const personalAcknowledge = (alarmData: IOverviewAlarmEvent): string => {
    const user = authorization.user.username
    const acknowledge = alarmData?.acknowledges?.filter(us => us.user === user).map(ack => ack.acknowledge)
    if (acknowledge === undefined || null) {
        return i18n('Acknowledge')
    } else if (acknowledge.length > 0) {
        return acknowledge[0]
    } else {
        return i18n('Acknowledge')
    }
}

export const AlarmDetails: React.FC<IProps> = ({ setAlarm, alarm, alarms, alarmBowties }) => {
    const [acknowledgeAlarm, setAcknowledgeAlarm] = useState<string>(personalAcknowledge(alarm))
    const [showingOptionsAcknowledgeAlarm, setShowingOptionsAcknowledgeAlarm] = useState<boolean>(false)
    const [events, setEvents] = useState<IAlarmEvent[]>()
    const [itemsLength, setItemsLength] = useState<number>()

    const currUserObj = authorization

    const popoverBtCodeFocus = (
        <Popover positionTop={50} id="popover-trigger-hover-focus">
            <div className="field">
                <span>{i18n('Bowtie Code')}</span>
            </div>
        </Popover>
    )

    const popoverTopEventFocus = (
        <Popover positionTop={50} id="popover-trigger-hover-focus">
            <div className="field">
                <span>{i18n('Top Event')}</span>
            </div>
        </Popover>
    )

    const popoverHazardFocus = (
        <Popover positionTop={50} id="popover-trigger-hover-focus">
            <div className="field">
                <span>{i18n('Hazard')}</span>
            </div>
        </Popover>
    )

    const popoverOperationFocus = (
        <Popover positionTop={50} id="popover-trigger-hover-focus">
            <div className="field">
                <span>{i18n('Operation')}</span>
            </div>
        </Popover>
    )

    const renderBowtieNames = (): JSX.Element[] => {
        return alarmBowties?.map((bt, idx) => {
            return (
                <li key={idx} className="bowtie-diagram-view">
                    <OverlayTrigger trigger={['hover', 'focus']} placement="top" overlay={popoverBtCodeFocus}>
                        <span>{bt.bowtieCode}</span>
                    </OverlayTrigger>
                    <span>{' | '}</span>
                    <OverlayTrigger trigger={['hover', 'focus']} placement="top" overlay={popoverTopEventFocus}>
                        <span>{bt.topEvent.name ? bt.topEvent.name : i18n('Undefined')}</span>
                    </OverlayTrigger>
                    <span>{' | '}</span>
                    <OverlayTrigger trigger={['hover', 'focus']} placement="top" overlay={popoverHazardFocus}>
                        <span>{bt.topEvent.hazard.name}</span>
                    </OverlayTrigger>
                    <span>{' | '}</span>
                    <OverlayTrigger trigger={['hover', 'focus']} placement="top" overlay={popoverOperationFocus}>
                        <span>{bt.topEvent.hazard.operation.description}</span>
                    </OverlayTrigger>
                </li>
            )
        })
    }

    const handleAknowledgeAlarm = async (alarm: IAlarmEvent): Promise<void> => {
        try {
            await updateAcknowledge({
                id: alarm.id,
                date: alarms?.get(alarm.id)?.date,
                liveTimestamp: alarms?.get(alarm.id)?.timestamp,
                user: currUserObj.user.username,
                userId: currUserObj.user.id,
                entityName: alarm.entity,
                acknowledge: acknowledgeAlarm
            })
            globalNotification.success(i18n('Acknowledge updated succesfully.'))
        } catch (error) {
            globalNotification.error('There was an error when trying to update acknowledge.')
        }
    }

    const handleSeeAlarm = async (alarm: IAlarmEvent): Promise<void> => {
        try {
            if (!alarm.seen_by && !alarm.acknowledges) {
                await updateSeenBy({
                    date: alarms?.get(alarm.id)?.date,
                    id: alarm.id,
                    entityName: alarm.entity,
                    liveTimestamp: alarms?.get(alarm.id)?.timestamp,
                    user: currUserObj.user.username,
                    userId: currUserObj.user.id
                })
            }
        } catch (error) {
            console.log(error)
        }
    }

    const get30DaysAgo = (): string => {
        const day = new Date().getTime() - 86400000 * 29
        const convertedDay = moment(new Date(day)).format('YYYY-MM-DD')

        return convertedDay
    }
    const handleGetTriggerLogInfo = async (): Promise<void> => {
        try {
            const params = {
                limit: 30,
                offset: 0,
                startDay: get30DaysAgo(),
                startHour: '',
                endDay: moment(new Date()).format('YYYY-MM-DD'),
                endHour: '',
                entityId: alarm?.id
            }
            const triggerLogInfo = await getAlarmTriggerLog(params)
            setEvents(triggerLogInfo.data)
            setItemsLength(triggerLogInfo.total)
        } catch (error) {}
    }

    const dateConverter = (date: number): string => {
        const newDate = new Date(date)
        const converted = moment(newDate).format('ddd, MMM DD, YYYY hh:mm:ss a')

        return `${converted}`
    }

    useEffect(() => {
        handleGetTriggerLogInfo()
        handleSeeAlarm(alarm)
        setAcknowledgeAlarm(personalAcknowledge(alarm))
        setShowingOptionsAcknowledgeAlarm(false)
        console.log(alarm)
    }, [alarm])

    useEffect(() => {
        if (alarm) {
            const alarmToAtt = alarms?.get(alarm.id)
            setAlarm({
                ...alarmToAtt,
                entityName: alarm.entityName
            })
        }
    }, [alarms])

    return (
        <AlarmDetailsContainer>
            {alarm === undefined ? (
                <div className="no-alarm-selected">{i18n('Select an alarm to see its details.')}</div>
            ) : (
                <>
                    <div className="details-header">
                        <div className={'title-notification-email'}>
                            <div className="ball-name-bundle">
                                <AlarmRiskBollNotification color={statusAlarmReturnColor(alarm?.status)} />
                                <label className={'label-title-email'}>
                                    {' '}
                                    {`${i18n('Alert on')} ${i18n(alarm?.entity)} "${alarm?.entityName}" `}
                                </label>
                            </div>
                            <label className={'label-time-notification'}>
                                <i className="fal fa-history" />
                                {i18n('Last triggered')}
                                <i className="fal fa-clock" />
                                {dateConverter(alarm?.date || new Date().getTime())}
                            </label>
                        </div>

                        <div className="hours-triggered">
                            <Button
                                className="no-outline-button"
                                bsStyle="primary"
                                onClick={() => setShowingOptionsAcknowledgeAlarm(!showingOptionsAcknowledgeAlarm)}
                            >
                                {acknowledgeAlarm !== i18n('Acknowledge')
                                    ? i18n(alarmType.find(alarm => alarm.value === acknowledgeAlarm).name)
                                    : i18n('Acknowledge')}
                                {showingOptionsAcknowledgeAlarm ? (
                                    <i className="fas fa-caret-up" />
                                ) : (
                                    <i className="fas fa-caret-down" />
                                )}
                            </Button>
                            <div
                                className="save-acknowledge"
                                onClick={() => {
                                    handleAknowledgeAlarm(alarm)
                                }}
                            >
                                <i className="fas fa-save" />
                                {i18n('Save acknowledge')}
                            </div>
                            {showingOptionsAcknowledgeAlarm && (
                                <div className={'option-acknowledge-alarms'}>
                                    {alarmType.map(at => {
                                        return (
                                            <label
                                                className={'ackowledge-alarms-item'}
                                                key={at.value}
                                                onClick={() => {
                                                    setAcknowledgeAlarm(at.value)
                                                    setShowingOptionsAcknowledgeAlarm(false)
                                                }}
                                            >
                                                {i18n(at.name)}
                                            </label>
                                        )
                                    })}
                                </div>
                            )}
                        </div>
                    </div>
                    <div className={'description-notification'}>
                        <RiskNameNotification color={statusAlarmReturnColor(alarm?.status)}>
                            {i18n(alarm?.status) || ''}
                        </RiskNameNotification>
                        <div>
                            <label>{i18n('BOWTIE CONTEXT:')}</label>
                            <ul>{renderBowtieNames()}</ul>
                        </div>
                    </div>

                    <div className={'alerts-message'}>
                        <div>
                            <label className={'title-information-tab'}>{i18n('Trigger Log')}</label>
                            <label className={'subtitle-information-tab'}>
                                {itemsLength}{' '}
                                {itemsLength === 1
                                    ? i18n('triggers in the last month single')
                                    : i18n('triggers in the last month')}
                            </label>
                        </div>
                        <div className="trigger-list">
                            {events
                                ?.sort((a, b) => {
                                    if (a.timestamp > b.timestamp) {
                                        return -1
                                    }
                                    if (a.timestamp < b.timestamp) {
                                        return 1
                                    }
                                })
                                .map((ev, idx) => (
                                    <TriggerLogMessage key={idx} date={ev.date} status={ev.status} />
                                ))}
                        </div>
                    </div>
                </>
            )}
        </AlarmDetailsContainer>
    )
}
